<template>
	<div>
		<el-dialog
			title="资产二维码"
			:visible.sync="dialogVisible"
			width="400px"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="dialog-qrcode">
				<img :src="data.qrCode" alt="二维码" class="qrCode" />
				<div class="name">{{ data.assetName }}</div>
				<div>资产编号：{{ data.assetNo }}</div>
				<div>所属项目：{{ community.name }}</div>
			</div>
			<span slot="footer">
				<el-button type="primary" @click="handlePrint" icon="fa fa-print">
					<span style="margin-left: 10px">打印</span>
				</el-button>
				<el-button @click="handleClose">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { getCurrentCommunity } from '@/utils/vc.js';
	export default {
		name: 'AssetLedgerQrcode',
		components: {},
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				community: getCurrentCommunity(),
			};
		},
		methods: {
			handlePrint() {},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	.dialog-qrcode {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		color: #666;
		.qrCode {
			width: 160px;
			height: 160px;
			border: 1px solid #dcdcdc;
			border-radius: 6px;
		}
		.name {
			color: #1c1c1c;
			font-size: 18px;
			font-weight: 600;
		}
	}
</style>
